import { EntityModel } from '@/interfaces'
import {
  ALL_PREFILTERED_TRAVELS_BLOCKS_QUERY,
  CREATE_PREFILTERED_TRAVELS_BLOCK_MUTATION,
  DELETE_PREFILTERED_TRAVELS_BLOCK_MUTATION,
  FORCE_DELETE_PREFILTERED_TRAVELS_BLOCK_MUTATION,
  SINGLE_PREFILTERED_TRAVELS_BLOCK_QUERY,
  UPDATE_PREFILTERED_TRAVELS_BLOCK_MUTATION,
} from './graphql'
import travelDestinationEntity from '@/entities/travelDestination/entity'
import travelTypeEntity from '@/entities/travelType/entity'

const cmsPrefilteredTravelsBlockModel: EntityModel = {
  name: 'prefilteredTravelsBlock',
  namePlural: 'prefilteredTravelsBlocks',
  uniqueName: 'cmsPrefilteredTravelsBlock',
  uniqueNamePlural: 'cmsPrefilteredTravelsBlocks',
  path: 'cms/blocks/prefiltered_travels_block',
  baseUrl: '/cms/blocks/prefiltered_travels_blocks',
  translationPrefix: 'entities:cmsPrefilteredTravelsBlock.',
  getDisplayName: (values: any) => {
    return 'Prefiltered Travels Block'
  },
  gql: {
    getAll: ALL_PREFILTERED_TRAVELS_BLOCKS_QUERY,
    getSingle: SINGLE_PREFILTERED_TRAVELS_BLOCK_QUERY,
    create: CREATE_PREFILTERED_TRAVELS_BLOCK_MUTATION,
    update: UPDATE_PREFILTERED_TRAVELS_BLOCK_MUTATION,
    delete: DELETE_PREFILTERED_TRAVELS_BLOCK_MUTATION,
    forceDelete: FORCE_DELETE_PREFILTERED_TRAVELS_BLOCK_MUTATION,
  },
  attributes: {
    destinations: {
      name: 'destinations',
      label: 'entities:cmsPrefilteredTravelsBlock.attributes.destinations.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return travelDestinationEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    travelTypes: {
      name: 'travelTypes',
      label: 'entities:cmsPrefilteredTravelsBlock.attributes.travelTypes.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return travelTypeEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    maxResults: {
      name: 'maxResults',
      label: 'entities:cmsPrefilteredTravelsBlock.attributes.maxResults.label',
      type: 'value',
      dataType: 'number',
      defaultInput: true,
      inputType: 'select',
      selectOptions: [
        {
          label: 'entities:cmsPrefilteredTravelsBlock.attributes.maxResults.selectOptions.0.label',
          value: '0',
        },
        {
          label: 'entities:cmsPrefilteredTravelsBlock.attributes.maxResults.selectOptions.4.label',
          value: '4',
        },
        {
          label: 'entities:cmsPrefilteredTravelsBlock.attributes.maxResults.selectOptions.8.label',
          value: '8',
        },
        {
          label: 'entities:cmsPrefilteredTravelsBlock.attributes.maxResults.selectOptions.12.label',
          value: '12',
        },
      ],
      validationType: 'string',
      validations: [],
    },
  },
}

export default cmsPrefilteredTravelsBlockModel
